import { FilterInput } from 'dashboards/types/filter';

import { useDashboardFilterParams } from './useDashboardFilterParams';

export type UseDashboardWidgetParamsOptions = {
  filters: FilterInput[];
  // Contains the available columns for the current metric or dataPool
  columns: Array<{ name: string; datatype: string }>;
};

/** Applies top level gateway and source labels filter to the filter input of data widgets */
export function useTopLevelDataWidgetFilters({
  filters,
  columns,
}: UseDashboardWidgetParamsOptions) {
  const params = useDashboardFilterParams();

  const hasGatewayIdColumn = columns.some(({ name }) => name === 'gateway_id');

  const gatewayFilter: FilterInput[] = [];

  if (
    'gateway_id' in params &&
    Boolean(params.gateway_id) &&
    hasGatewayIdColumn
  ) {
    gatewayFilter.push({
      column: 'gateway_id',
      operator: 'EQUALS',
      value: params.gateway_id,
    });
  }

  const hasSourceIdColumn = columns.some(({ name }) => name === 'source_id');

  const sourceIdsFilter: FilterInput[] = [];

  // If source_id column exists, and stream_ids is not undefined,
  // we need to add a source_id filter. Note that empty stream_ids means
  // selected tags didnt have any sources. Undefined stream_ids means
  // no tags were selected.
  if (
    'stream_ids' in params &&
    params.stream_ids !== undefined &&
    params.stream_ids.length &&
    hasSourceIdColumn
  ) {
    const [firstSourceId, ...sourceIds] = params.stream_ids;

    const sourceFilters: FilterInput = {
      column: 'source_id',
      operator: 'EQUALS',
      value: firstSourceId,
      or: sourceIds.map((value) => ({
        column: 'source_id',
        operator: 'EQUALS',
        value,
      })),
    };

    sourceIdsFilter.push(sourceFilters);
  }

  // Compose the final filters implicitly AND connected
  return [...filters, ...gatewayFilter, ...sourceIdsFilter];
}
